/**
 *  Handles fetch errors.
 *  @type {Object} Response
 */
const handleErrors = (response: Response): Response => {
  if (!response.ok) {
    throw response;
  }
  return response;
}

export {
  handleErrors
}
